import React from 'react'
import PropTypes from 'prop-types'
import ExitToApp from '@mui/icons-material/ExitToApp'

const ExitToAppIcon = ({ height, width, ...more }) => {
	
	return (
		<ExitToApp
			height={height}
			width={width}
			{...more}
		/>
	)
}

ExitToAppIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default ExitToAppIcon
